var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2467_663)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99589 8.47052C6.02268 8.47056 6.12649 8.47164 6.28235 8.49875L6.26118 8.84463C6.25411 9.02816 6.09882 9.1764 5.9153 9.1764C5.50588 9.1764 5.22353 9.2964 5.03294 9.5364C4.60235 10.087 4.75059 11.1811 4.84235 11.5623C4.87059 11.6682 4.84235 11.7811 4.77883 11.8658C4.70824 11.9505 4.60941 11.9999 4.50353 11.9999H3.17647C2.97882 11.9999 2.82353 11.8446 2.82353 11.647V8.47052H5.99589ZM9.91976 0.195242C9.99247 0.0484175 10.1548 -0.0271075 10.3165 0.0088925C10.476 0.0470112 10.5882 0.188892 10.5882 0.352655V3.56512C11.3929 3.72889 12 4.44183 12 5.29383C12 6.14583 11.3929 6.85948 10.5882 7.02324V10.235C10.5882 10.3988 10.476 10.5414 10.3165 10.5788C10.2898 10.5849 10.2626 10.588 10.2353 10.5879C10.1033 10.5879 9.98047 10.5145 9.91976 10.3931C8.62024 7.79477 6.02612 7.76442 6 7.76442H2.47059C1.49718 7.76442 0.705881 6.97312 0.705881 5.99972V5.64677H0.352944C0.158119 5.64677 0 5.48936 0 5.29384C0 5.09901 0.158119 4.94089 0.352938 4.94089H0.705881V4.58795C0.705881 3.61524 1.49718 2.82324 2.47059 2.82324H5.99929C6.10518 2.82254 8.62729 2.77948 9.91976 0.195242Z",
    fill: "#006500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2467_663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.d23d709c935d435a08ade699ff88dfa0.svg";
export { ForwardRef as ReactComponent };